import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/api";

export const getCompanyList = () => axiosInstance.get(API_ENDPOINTS.getCompanyList);
export const createCompany = (data: { parentId?: number | null; name: string; email?: string; phone?: string; address?: string }) =>
    axiosInstance.post(API_ENDPOINTS.createCompany, data);
export const updateCompany = (data: { id: number; parentId?: number | null; name: string; email?: string; phone?: string; address?: string }) =>
    axiosInstance.put(API_ENDPOINTS.updateCompany, data);
export const deleteCompany = (id: number) => axiosInstance.delete(API_ENDPOINTS.deleteCompany(id));
